<template>
	<div id="headerComponent">
		<div class="leftSection">
            <div class="leftLogoBox">
                <img src="../assets/images/icon/logo_white.png" alt="" class="logo">
            </div>
            <div class="platName">
                技工大赛管理平台
            </div>
		</div>
        <div class="rightSection">
            <div class="userInfoBox toggleBox">
                <div class="title">
                    <span class='el-icon-user-solid'></span>
                    <span>{{userInfo.phone}}</span>
                    <span>{{userInfo.realName}}</span>
                    <span class="el-icon-caret-bottom"></span>
                </div>
                <div class="content toggleBoxContent">
                    <div class="itemBox">
                        <span class="label">公司</span>
                        <span class="text">{{userInfo.companyName}}</span>
                    </div>
                    <div class="itemBox">
                        <span class="label">手机</span>
                        <span class="text">{{userInfo.phone}}</span>
                    </div>
                    <div class="itemBox">
                        <span class="label">姓名</span>
                        <span class="text">{{userInfo.realName}}</span>
                    </div>
                    <div class="itemBox">
                        <span class="label">职位</span>
                        <span class="text">{{userInfo.position}}</span>
                    </div>
                    <div class="itemBox">
                        <span class="label">账号ID</span>
                        <span class="text">{{userInfo.adminId}}</span>
                    </div>
                    
                </div>
            </div>
            <div class="platMenuBox toggleBox">
                 <div class="title">
                    <span class='el-icon-s-grid'></span>
                    <span>模块</span>
                    <span class="el-icon-caret-bottom"></span>
                </div>
                <div class="content toggleBoxContent">
                    <ul>
                        
                        <li  class="itemBox btn" v-for="(platList,index) in platInfo" @click="toOtherPlat(platList)"
                            :class="{active:currentSysId==platList.sysId}">
                            <span>{{platList.sysSystemName}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="loginOutBox toggleBox">
                <div class="title">
                    <span class='el-icon-s-tools'></span>
                </div>
                <div class="content toggleBoxContent">
                    <ul>
                        <li class="line itemBox btn" @click="toEditPwd" >修改密码</li>
                        <li  class="itemBox btn" @click="loginOut">
                            <span>退出登录</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
	import { utils,json } from '@/common/common.js'
	export default {
		name: 'myheader',
		data() {
			return {
				userInfo:{},
                platInfo:[]
			}
		},
		components: {},
		props: ['bgColor'],
		computed: {
            platWordData(){
                let platsData=[]
                if(utils.getCurrentApi()=='dev'){
                    platsData=json.platLists_dev
                }
                if(utils.getCurrentApi()=='test'){
                    platsData=json.platLists_test
                }
                if(utils.getCurrentApi()=='prod'){
                    platsData=json.platLists_prod 
                }
                
                return platsData
            },
            currentSysId(){
                return utils.getSysId()
            }
        },
		methods: {
            toEditPwd(){
                this.$router.push("/editPwd")
            },
            loginOut(){
                utils.setCookie('isLoginedYjjAdminMultiActive','')//1.登录标记
                utils.setCookie("userInfo_multiActive", '')
                utils.setCookie("platInfo_multiActive", '')
                // utils.setCookie("platAndMenuInfo_multiActive",'')
                sessionStorage.setItem('searchObjJson','') //2.搜索条件
                this.$router.push("/login")
            },
            toOtherPlat(list){
                console.log(list)
                if(this.currentSysId==list.sysId){
                    alert("已经是当前系统")
                }else{
                    // let url=''
                    // this.platWordData.forEach(function(item,index){
                    //     if(item.value==list.sysId){
                    //         url=item.url
                    //         return false
                    //     }
                    // })
                    // window.open(url,'_blank')
					window.open('//' + list.url,'_blank')
                }
                
            },
		},
		mounted() {
            // console.log(utils.getCookie('userInfo_multiActive'),"订货会系统的userinfo-------------------------")
            // console.log(utils.getCookie('platAndMenuInfo_multiActive'),"订货会系统的platAndMenuInfo")
           
            let a=utils.getCookie('userInfo_multiActive')
            let b=utils.getCookie('platInfo_multiActive')
             console.log(a)
            console.log(b)
            
            if(a&&b){
                this.userInfo=JSON.parse(a) 
                this.platInfo=JSON.parse(b) 
				const mgtEnvLink = {
					dev: 'mgt.dev.yijiajiayun.com',
					test: 'mgt.test.yijiajiayun.com',
					prod: 'mgt.yijiajiayun.com'
				}
				const mgtNav = {
					sysId: 'mgt-nav',
					sysSystemName: '衣加加管理后台导航',
					url: mgtEnvLink[utils.getCurrentApi()] || mgtEnvLink['dev']
				}
				const navList = JSON.parse(b) || []
				this.platInfo = [ mgtNav, ...navList ]

            }
           
            
		}
	}
</script>

<style scoped lang="scss">
	.el-dropdown{color:#fff;}
	.el-popper[x-placement^=bottom]{margin:0;}
	// *{outline: 1px solid red;}
	#headerComponent {
		height: 1.25rem;
		line-height: 1.25rem;
		position: relative;
		color: #fff;
		.toggleButton{
			padding:0 0.2rem;
		}
		.leftSection {
            display: flex;;
			.platName{padding:0 0.5rem; font-size: 16px;line-height: 50px;;}
            .leftLogoBox{
                height: 50px;background: #3b4a63; width: 200px;; text-align: center; padding-top:5px;display: inline-block;
                .logo{height: 35px;width:auto; }
            }
		}

		.rightSection {
			position: absolute; z-index:100;
			right: 1rem; height: 1.25rem;   
			top: 0;  
			// 第一块
			.userInfoBox {
				display: inline-block; 
                .content{width: 210px; padding:5px; font-size: 12px;
                    .itemBox{padding:5px 10px;;text-align: left; line-height: 15px;}
                    .label{display: inline-block;width: 50px;color:#aaa;text-align: justify;text-align-last: justify;margin-right: 10px;}
                }
			}
			// 第2块
			.platMenuBox {
				display: inline-block; vertical-align: top;
                
			}
			// 第3块
			.loginOutBox {
				display: inline-block; vertical-align: top;
			}
            .title{min-width: 80px;text-align: center;padding:0 10px;}
            .content{background: #fff; color:#333;position: absolute;min-width: 150px;border:1px solid #eee;box-shadow: 0 0 3px #ded; text-align: center;
                .itemBox{padding:0;margin:0;line-height: 20px;padding:10px;;}
                .itemBox.btn:hover{background: skyblue;color:#fff;cursor:pointer;}
                .itemBox.active{color:blue;}
                
                
                
            }
            .toggleBox{position: relative;}
            .toggleBox .toggleBoxContent{display: none;right:0px;}
            .toggleBox:hover .toggleBoxContent{display: block;}
            .toggleBox:hover .title{cursor: pointer;background: skyblue;}
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/headerComponent.vue